import { render, staticRenderFns } from "./PersonGender.vue?vue&type=template&id=30aa11da&scoped=true&"
import script from "./PersonGender.vue?vue&type=script&lang=js&"
export * from "./PersonGender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30aa11da",
  null
  
)

export default component.exports